import {http} from "@/api/HttpClient.ts";
import {PlayerViewSelection, PlayerViewSelectionUpdate} from "@/player/PlayerViewHooks.ts";

export async function getCampaignPlayerView(campaignId: string): Promise<PlayerViewSelection> {
    const response = await http.get<PlayerViewSelection>(`/campaigns/${campaignId}/player-view`);
    return response.data;
}

export async function updateCampaignPlayerView(
    campaignId: string,
    update: PlayerViewSelectionUpdate,
): Promise<PlayerViewSelection> {
    const response = await http.put<PlayerViewSelection>(`/campaigns/${campaignId}/player-view`, update);
    return response.data;
}
